<div class="card mb-0 flex-shrink-0">
  <div class="card-body py-2 d-flex flex-column gap-2">
    <div class="d-flex flex-wrap align-items-center gap-2">
      <h6 class="fw-bold text-primary mb-0 me-1">{{ 'period' | translate }}</h6>
      <button type="button" class="btn btn-sm"
        [class.btn-primary]="activePreset === 'today'"
        [class.btn-outline-secondary]="activePreset !== 'today'"
        (click)="changePreset('today')">
        {{ 'today' | translate }}
      </button>
      <button type="button" class="btn btn-sm"
        [class.btn-primary]="activePreset === '7days'"
        [class.btn-outline-secondary]="activePreset !== '7days'"
        (click)="changePreset('7days')">
        7 {{ 'days' | translate }}
      </button>
      <button type="button" class="btn btn-sm"
        [class.btn-primary]="activePreset === '30days'"
        [class.btn-outline-secondary]="activePreset !== '30days'"
        (click)="changePreset('30days')">
        30 {{ 'days' | translate }}
      </button>
      <button type="button" class="btn btn-sm"
        [class.btn-primary]="activePreset === 'currentMonth'"
        [class.btn-outline-secondary]="activePreset !== 'currentMonth'"
        (click)="changePreset('currentMonth')">
        {{ 'currentMonth' | translate }}
      </button>
      <button type="button" class="btn btn-sm"
        [class.btn-primary]="activePreset === 'custom'"
        [class.btn-outline-secondary]="activePreset !== 'custom'"
        (click)="changePreset('custom')">
        {{ 'customize' | translate }}
      </button>
      <span class="small text-muted text-nowrap ms-auto" *ngIf="appliedRangeLabel">
        <i class="fas fa-calendar-alt me-1"></i>{{ appliedRangeLabel }}
      </span>
    </div>

    <div class="d-flex flex-wrap align-items-center gap-2" *ngIf="activePreset === 'custom'">
      <div class="input-group input-group-sm flex-nowrap flex-grow-0 w-auto">
        <span class="input-group-text px-2">{{ 'lumPeriodFrom' | translate }}</span>
        <input type="date" class="form-control w-auto flex-grow-0" id="historyAnalyticsStartDate"
          name="historyAnalyticsStartDate" [(ngModel)]="startDate" [attr.aria-label]="'startDate' | translate">
      </div>
      <div class="input-group input-group-sm flex-nowrap flex-grow-0 w-auto">
        <span class="input-group-text px-2 text-capitalize">{{ 'until' | translate }}</span>
        <input type="date" class="form-control w-auto flex-grow-0" id="historyAnalyticsEndDate"
          name="historyAnalyticsEndDate" [(ngModel)]="endDate" [attr.aria-label]="'endDate' | translate">
      </div>
      <button type="button" class="btn btn-sm btn-primary flex-shrink-0 text-nowrap"
        (click)="applyCustomRange()">
        {{ 'do_update' | translate }}
      </button>
    </div>
  </div>
</div>
